import { render } from "./ProjectViewOnly.vue?vue&type=template&id=34263d4e"
import script from "./ProjectViewOnly.vue?vue&type=script&lang=js"
export * from "./ProjectViewOnly.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__